/**
 * Add behavior to type/category control for partners
 */
const getAll = (elLabels) => {
	elLabels[0].firstElementChild.checked = true
	const event = new Event('change')
	elLabels[0].firstElementChild.dispatchEvent(event)
}
export const getFiltered = ({ FWP, elCats }, filters) => {
	Object.keys(filters).forEach((key) => {
		FWP.facets[key] = filters[key]
	})
	FWP.fetchData()
	FWP.setHash()
	elCats.dataset.cat = 'filtered'
}
export const partnersFeedFilter = (feed) => {
	const { FWP, elCats, elLabels } = feed
	// for each label
	elLabels.forEach((elLabel) => {
		// get the nested radio input
		const input = elLabel.firstElementChild
		// load appropriate category when user checks a radio button
		input.addEventListener('change', () => {
			// if we have a value then clear subcategories and show this category
			if (input.value !== 'all') {
				getFiltered(feed, { partner_category: [input.value], partner_subcategory: [] })
				// if we have no value (i.e. All is chosen) then reset
			} else {
				// i've no idea why a timeout is needed but otherwise it forces previous input to be re-selected
				setTimeout(() => FWP.reset(), 99)
				elCats.dataset.cat = 'all'
			}
		})
		// on click of labels
		elLabel.addEventListener('click', () => {
			// deselect already-selected radio buttons (mimics facetwp's functinality)
			if (input.value === FWP.facets.partner_category?.[0]) {
				getAll(elLabels)
			}
		})
	})
}
